import { simbaStyled } from '@naf-simba/theme';
import ThumbsDown from '../../../assets/images/ThumbsDown.svg';
import Fireworks from '../../../assets/images/Fireworks.svg';
import { CompetitionStyleVariant } from './Competition.types';

export const Wrapper = simbaStyled<'div', { $style: CompetitionStyleVariant }>('div')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing('l'),
  marginBottom: theme.spacing('l'),
}));

export const Container = simbaStyled<'div', { $style: CompetitionStyleVariant }>('div')(({ theme, $style }) => {
  const { common, secondary } = theme.palette.simba.colors;
  const isSpruce = $style === 'spruce';

  return {
    maxWidth: '564px',
    padding: theme.spacing('l'),
    borderRadius: theme.spacing('lm'),
    boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.24)',
    color: isSpruce ? common.white : common.black,
    backgroundColor: isSpruce ? secondary[900] : common.white,
  };
});

export const Content = simbaStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  p: {
    margin: 0,
  },

  h3: {
    margin: 0,
    marginTop: theme.spacing('m'),
  },
}));

export const FireworksImage = simbaStyled(Fireworks)(({ theme }) => ({
  marginTop: theme.spacing('ml'),
}));

export const ThumbsDownImage = simbaStyled(ThumbsDown)(({ theme }) => ({
  marginTop: theme.spacing('ml'),
}));

export const TermsContent = simbaStyled('div')(() => ({
  'h1, h2, h3': {
    margin: 0,
  },
}));

export const TermsTitle = simbaStyled('div')(({ theme }) => ({
  margin: `0 0 ${theme.spacing('ml')} 0`,
}));

export const Ingress = simbaStyled('div')(({ theme }) => ({
  marginBottom: theme.spacing('ml'),
}));

export const LinkWrapper = simbaStyled('div')(({ theme }) => ({
  marginTop: theme.spacing('ml'),
}));
